import { SharedState } from '@trello/shared-state';

export type ViewName =
  | 'aboutBoard'
  | 'aboutTemplate'
  | 'activity'
  | 'archive'
  | 'background'
  | 'backgroundColor'
  | 'backgroundPhoto'
  | 'collections'
  | 'default'
  | 'labels'
  | 'settings'
  | 'share'
  | 'stickers';

export const boardMenuSharedState = new SharedState({
  currentViewName: 'default' as ViewName,
  viewHistory: ['default' as ViewName],
  isMainView: true,
});
